import React from 'react';
import { useState, useEffect } from 'react';

interface IProps {
  tickets: any;
  info: any;
  index: number;
  selectedTicketIdx: any;
  setSelectedTicketIdx: any;
  markAsRead: any;
  isRead: any;
}

const NotificationCard = (props: IProps) => {
  const { info, index, selectedTicketIdx, setSelectedTicketIdx, markAsRead, isRead, tickets } =
    props;

  const [skipUseEffect, setSkipUseEffect] = useState(false);

  useEffect(() => {
    if (
      tickets.length > 0 &&
      selectedTicketIdx === 0 &&
      tickets[0]?.uuid &&
      !tickets[0]?.read &&
      !tickets[0]?.isBeingRead &&
      !skipUseEffect
    ) {
      tickets[0].isBeingRead = true;
      markAsRead(tickets[0].uuid);
    }

    if (skipUseEffect) {
      setSkipUseEffect(false);
    }
  }, [tickets.length, tickets[0]?.uuid, selectedTicketIdx, skipUseEffect]);

  const handleClick = () => {
    setSelectedTicketIdx(index);

    if (index === 0) {
      setSkipUseEffect(true);
    }

    if (!info.read) {
      if (index === 0) {
        tickets[0].isBeingRead = true;
      }
      markAsRead(info.uuid);
    }
  };

  return (
    <div
      key={info.uuid}
      className={` rounded-lg pt-3.5 pl-3.5 pr-2 pb-1.5 cursor-pointer border ${info?.read ? 'bg-none' : 'bg-[#006BEA30]'}
      ${selectedTicketIdx === index ? 'border-[#006BEA]' : 'border-[#696969]'}`}
      onClick={handleClick}
    >
      <div className="flex justify-between items-center mb-2">
        <label className="text-sm text-white cursor-pointer max-w-40 md:max-w-60 lg:max-w-96 overflow-hidden text-ellipsis whitespace-nowrap font-medium">
          {info.message}
        </label>
      </div>
      <div className="flex">
        <label className="text-xs text-white font-regular cursor-pointer max-w-40 md:max-w-60 lg:max-w-96 overflow-hidden text-ellipsis whitespace-nowrap">
          {info.title}
        </label>
      </div>

      <div className="flex justify-end mt-1">
        <label className="text-xs font-bold text-[#D7D7D7] text-right cursor-pointer">
          {info.createdTime}
        </label>
      </div>
    </div>
  );
};

export default NotificationCard;
